import React from "react";
import QurealCanvasWrapper from "./QurealCanvasWrapper";
import QurealBlogs from "../../blog_bot/QurealBlogs";
import { Button, message } from "antd";
import { useMeasure } from "react-use";

function QurealImageCanvas({ data, closeBtn }) {
    const [ref, { x, y, width, height, top, right, bottom, left }] = useMeasure();


    return (
        <QurealCanvasWrapper
            title="Image"
            actions={[
                <Button type="primary">Download</Button>,
                closeBtn
            ]}
            header_height={50}
        >
            <div ref={ref} style={{
                width: "100%",
                height: "100%",
                maxHeight: "90vh",
                overflowY: "hidden",
            }}>
                <img src={data?.value} style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                }} />
            </div>

        </QurealCanvasWrapper>
    );
}

export default QurealImageCanvas;
